import React, { useState, useEffect, useCallback } from "react";
import { Offcanvas } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from "../Context/auth";
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import GridProdutos from "../Components/ProdutosGrid/produtosgrid";
import Pagination from "../Components/Pagination/Pagination";
import Swal from 'sweetalert2';
import './Produtos.css';

function Produtos() {
    const { currentUser, appUserData } = useAuth();
    const [produtos, setProdutos] = useState([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState([]); // Novo estado para exibição
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (appUserData && appUserData['ler_produtos'] === false) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para visualizar esta tela.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home');
            });
        }
    }, [appUserData, navigate]);

    // Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);

    // Filtros
    const [showFiltros, setShowFiltros] = useState(false);
    const [listaGrades, setListaGrades] = useState([]);

    const [filtrosForm, setFiltrosForm] = useState({
        codigo: '',
        descricao: '',
        marca: '',
        fornecedor: '',
        valor_venda_min: '',
        valor_venda_max: '',
        valor_compra_min: '',
        valor_compra_max: '',
        status: 'Ativo', // Padrão
        observacoes: '',
        cor: '',
        grade_id: ''
    });

    const [filtrosAplicados, setFiltrosAplicados] = useState({
        codigo: '',
        descricao: '',
        marca: '',
        fornecedor: '',
        valor_venda_min: '',
        valor_venda_max: '',
        valor_compra_min: '',
        valor_compra_max: '',
        status: 'Ativo',
        observacoes: '',
        cor: '',
        grade_id: ''
    });

    const [pesquisa, setPesquisa] = useState('');
    const [textoPesquisa, setTextoPesquisa] = useState('');
    const [trigger, setTrigger] = useState(0);

    const buscarDados = useCallback(async (termoBusca = '', filtros = {}) => {
        if (!currentUser) {
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const url = new URL(`${API_URL}/api/produtos`);

            // Client-side filtering: Fetch ALL
            // url.searchParams.append('search', termoBusca);
            // if (filtros.cor) url.searchParams.append('cor', filtros.cor);
            // if (filtros.grade_id) url.searchParams.append('gradeId', filtros.grade_id);

            const response = await fetch(url.toString(), {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Falha ao buscar produtos.');
            const data = await response.json();
            setProdutos(data); // "produtos" now holds ALL data
            setProdutosFiltrados(data);
        } catch (error) {
            setErro('Ocorreu um erro ao carregar os produtos.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [currentUser]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setTextoPesquisa(pesquisa);
        }, 500); // Debounce de 500ms para a pesquisa

        return () => clearTimeout(timer);
    }, [pesquisa]);

    useEffect(() => {
        // Fetch only on mount or trigger update. filtering is handled by the other useEffect
        buscarDados();
    }, [buscarDados, trigger]);

    // Busca de Grades para o Select
    useEffect(() => {
        if (!currentUser) return;
        const fetchGrades = async () => {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/grades`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (response.ok) {
                    const data = await response.json();
                    setListaGrades(data);
                }
            } catch (error) {
                console.error("Erro ao carregar grades", error);
            }
        };
        fetchGrades();
    }, [currentUser]);

    // Lógica de Filtragem Avançada + Texto Pesquisa
    useEffect(() => {
        let resultado = [...produtos];

        // 0. Texto Pesquisa (Quick Search)
        if (textoPesquisa) {
            const lowerBusca = textoPesquisa.toLowerCase();
            resultado = resultado.filter(p =>
                (p.descricao && p.descricao.toLowerCase().includes(lowerBusca)) ||
                (p.codigo && p.codigo.toLowerCase().includes(lowerBusca)) ||
                (p.marca_nome && p.marca_nome.toLowerCase().includes(lowerBusca)) ||
                (p.fornecedor_nome && p.fornecedor_nome.toLowerCase().includes(lowerBusca))
            );
        }

        // 1. Código (Advanced Filter)
        if (filtrosAplicados.codigo) {
            resultado = resultado.filter(p => (p.codigo || '').toLowerCase().includes(filtrosAplicados.codigo.toLowerCase()));
        }
        // 2. Descrição
        if (filtrosAplicados.descricao) {
            resultado = resultado.filter(p => (p.descricao || '').toLowerCase().includes(filtrosAplicados.descricao.toLowerCase()));
        }
        // 3. Marca
        if (filtrosAplicados.marca) {
            resultado = resultado.filter(p => (p.marca_nome || '').toLowerCase().includes(filtrosAplicados.marca.toLowerCase()));
        }
        // 4. Fornecedor
        if (filtrosAplicados.fornecedor) {
            resultado = resultado.filter(p => (p.fornecedor_nome || '').toLowerCase().includes(filtrosAplicados.fornecedor.toLowerCase()));
        }
        // 5. Valor Venda
        if (filtrosAplicados.valor_venda_min) {
            const min = parseFloat(filtrosAplicados.valor_venda_min.replace(',', '.'));
            resultado = resultado.filter(p => parseFloat(p.valor_venda) >= min);
        }
        if (filtrosAplicados.valor_venda_max) {
            const max = parseFloat(filtrosAplicados.valor_venda_max.replace(',', '.'));
            resultado = resultado.filter(p => parseFloat(p.valor_venda) <= max);
        }
        // 5.1 Valor Compra
        if (filtrosAplicados.valor_compra_min) {
            const min = parseFloat(filtrosAplicados.valor_compra_min.replace(',', '.'));
            resultado = resultado.filter(p => parseFloat(p.valor_compra) >= min);
        }
        if (filtrosAplicados.valor_compra_max) {
            const max = parseFloat(filtrosAplicados.valor_compra_max.replace(',', '.'));
            resultado = resultado.filter(p => parseFloat(p.valor_compra) <= max);
        }
        // 6. Status
        if (filtrosAplicados.status) {
            if (filtrosAplicados.status === 'Ativo') {
                resultado = resultado.filter(p => p.status !== 'Inativo');
            } else if (filtrosAplicados.status === 'Inativo') {
                resultado = resultado.filter(p => p.status === 'Inativo');
            }
        }
        // 7. Observações
        if (filtrosAplicados.observacoes) {
            resultado = resultado.filter(p => (p.observacoes || '').toLowerCase().includes(filtrosAplicados.observacoes.toLowerCase()));
        }
        // 8. Cor (Verifica no array colorsList se existir, ou campo texto)
        if (filtrosAplicados.cor) {
            const termoCor = filtrosAplicados.cor.toLowerCase();
            resultado = resultado.filter(p => {
                // Supõe que cores venham populadas ou verifica se há propriedade. 
                // Se não tiver lista carregada, tenta string. Ajuste conforme modelo real.
                if (Array.isArray(p.colorsList)) {
                    return p.colorsList.some(c => c.toLowerCase().includes(termoCor));
                }
                return false;
            });
        }
        // 9. Grade (Select)
        if (filtrosAplicados.grade_id) {
            resultado = resultado.filter(p => {
                if (Array.isArray(p.gradesList)) {
                    return p.gradesList.some(g => String(g.id) === String(filtrosAplicados.grade_id));
                }
                return false;
            });
        }

        setProdutosFiltrados(resultado);
        setCurrentPage(1); // Reseta para a primeira página sempre que os filtros mudarem
    }, [produtos, filtrosAplicados, textoPesquisa]);

    const handleFiltroChange = (e) => {
        const { name, value } = e.target;
        setFiltrosForm(prev => ({ ...prev, [name]: value }));
    };

    const handleAplicarFiltros = () => {
        setFiltrosAplicados(filtrosForm);
        setShowFiltros(false);
    };

    const handleLimparFiltros = () => {
        const reset = {
            codigo: '',
            descricao: '',
            marca: '',
            fornecedor: '',
            valor_venda_min: '',
            valor_venda_max: '',
            valor_compra_min: '',
            valor_compra_max: '',
            status: 'Ativo',
            observacoes: '',
            cor: '',
            grade_id: ''
        };
        setFiltrosForm(reset);
        setFiltrosAplicados(reset);
    };

    const handleKeyDownFiltros = (e) => {
        if (e.key === 'Enter') handleAplicarFiltros();
    };

    const deleteProduto = async (id) => {
        // Validation for Delete
        if (appUserData && appUserData['excluir_produtos'] === false) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Este usuário não possui permissão de exclusão. Por favor, contate o administrador.',
                confirmButtonColor: '#2185c6'
            });
            return;
        }

        const result = await Swal.fire({
            title: "Você tem certeza?",
            text: "Cores e grades associadas a este produto também serão excluídas. Esta ação não poderá ser revertida!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2185c6",
            cancelButtonColor: "#DC3545",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar"
        });

        if (result.isConfirmed) {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/produtos/${id}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Falha ao deletar produto.');
                }

                setTrigger(Date.now());
                Swal.fire("Excluído!", "O produto foi removido.", "success");
            } catch (error) {
                console.error("Erro ao deletar o produto: ", error);
                Swal.fire("Erro!", error.message, "error");
            }
        }
    };

    const handleAtualizar = () => {
        setPesquisa('');
        setTextoPesquisa('');
        setTrigger(Date.now());
    };

    const handlePesquisar = () => {
        setTextoPesquisa(pesquisa);
    };

    // Cálculos de Paginação
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentProdutos = produtosFiltrados.slice(indexOfFirstItem, indexOfLastItem);

    // Handler para mudança de página
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const changeItemsPerPage = (newLimit) => {
        setItemsPerPage(newLimit);
        setCurrentPage(1); // Volta para a primeira página ao mudar o limite
    };

    if (loading) {
        return (
            <div className="produtos-page-container" style={{ display: 'flex', paddingTop: 0 }}>
                <MenuLateral />
                <div className="d-flex justify-content-center align-items-center w-100 flex-column" style={{ marginTop: '100px' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </div>
                    <p className="mt-2 text-muted">Carregando produtos...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="produtos-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />

            <div className="content-with-sidebar">
                <div className="produtos-header">
                    <h1 className="produtos-title">
                        <i className="fas fa-box-open text-primary"></i>
                        Listagem de <span className="highlight">Produtos</span>
                    </h1>
                </div>

                <main className="produtos-content">
                    <div className="produtos-controls">
                        <Link
                            to="/app/novoproduto"
                            className="btn-primary-custom me-2"
                            onClick={(e) => {
                                // Validation for Create
                                if (appUserData && appUserData['cadastrar_produtos'] === false) {
                                    e.preventDefault();
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Acesso Negado',
                                        text: 'Este usuário não possui permissão de cadastro. Por favor, contate o administrador.',
                                        confirmButtonColor: '#2185c6'
                                    });
                                }
                            }}
                        >
                            <i className="fas fa-plus"></i> Novo Produto
                        </Link>
                        <div className="search-wrapper">
                            <i className="fas fa-search search-icon"></i>
                            <input
                                type="text"
                                className="search-input-custom"
                                placeholder="Pesquisar por descrição, código, marca..."
                                value={pesquisa}
                                onChange={(e) => setPesquisa(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handlePesquisar()}
                            />
                        </div>

                        {(() => {
                            const hasActiveFilters = (
                                filtrosAplicados.codigo ||
                                filtrosAplicados.descricao ||
                                filtrosAplicados.marca ||
                                filtrosAplicados.fornecedor ||
                                filtrosAplicados.status !== 'Ativo' ||
                                filtrosAplicados.valor_venda_min ||
                                filtrosAplicados.valor_venda_max ||
                                filtrosAplicados.valor_compra_min ||
                                filtrosAplicados.valor_compra_max ||
                                filtrosAplicados.observacoes ||
                                filtrosAplicados.cor ||
                                filtrosAplicados.grade_id
                            );

                            return (
                                <button
                                    className={`btn-icon-custom ${hasActiveFilters ? 'btn-icon-active' : ''}`}
                                    onClick={() => setShowFiltros(true)}
                                    title={hasActiveFilters ? "Filtros Ativos" : "Filtros Avançados"}
                                >
                                    <i className="fas fa-filter"></i>
                                    {hasActiveFilters && (
                                        <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle" style={{ transform: 'translate(-30%, -30%)' }}>
                                            <span className="visually-hidden">Filtros ativos</span>
                                        </span>
                                    )}
                                </button>
                            );
                        })()}

                        <button className="btn-icon-custom" onClick={handleAtualizar} disabled={loading} title="Atualizar Lista">
                            <i className={`fas fa-sync-alt ${loading ? 'fa-spin' : ''}`}></i>
                        </button>
                    </div>

                    {erro && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{erro}</div>
                        </div>
                    )}

                    <div className="produtos-grid-container">
                        <GridProdutos
                            arrayProdutos={currentProdutos}
                            clickDelete={deleteProduto}
                            userPermissions={appUserData}
                        />
                    </div>

                    {textoPesquisa && (
                        <div className="mt-3 text-end px-1 mb-5">
                            <button className="btn btn-link text-decoration-none btn-sm p-0 ms-2 text-secondary" onClick={() => { setPesquisa(''); setTextoPesquisa(''); }}>
                                <i className="fas fa-times"></i> Limpar pesquisa: "{textoPesquisa}"
                            </button>
                        </div>
                    )}
                </main>
            </div>

            {/* Componente de Paginação Flutuante */}
            <Pagination
                totalItems={produtosFiltrados.length}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={paginate}
                onItemsPerPageChange={changeItemsPerPage}
                loading={loading}
            />

            {/* --- SIDEBAR DE FILTROS AVANÇADOS --- */}
            <Offcanvas show={showFiltros} onHide={() => setShowFiltros(false)} placement="end" style={{ zIndex: 10500 }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title><i className="fas fa-filter me-2"></i>Filtros Avançados</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="d-grid gap-3" onKeyDown={handleKeyDownFiltros}>

                        <div className="d-grid gap-2">
                            <button className="btn btn-primary-custom" onClick={handleAplicarFiltros}>
                                <i className="fas fa-check me-2"></i>Aplicar Filtros
                            </button>
                            <button className="btn btn-outline-secondary" onClick={handleLimparFiltros}>
                                <i className="fas fa-eraser me-2"></i>Limpar Filtros
                            </button>
                        </div>

                        <hr className="m-0" />

                        {/* Status (Primeiro) */}
                        <div>
                            <label className="form-label small fw-bold">Status</label>
                            <select className="form-select" name="status" value={filtrosForm.status} onChange={handleFiltroChange}>
                                <option value="">Todos</option>
                                <option value="Ativo">Ativo</option>
                                <option value="Inativo">Inativo</option>
                            </select>
                        </div>

                        {/* Código */}
                        <div>
                            <label className="form-label small fw-bold">Código</label>
                            <input type="text" className="form-control" name="codigo" value={filtrosForm.codigo} onChange={handleFiltroChange} placeholder="Ex: 001" />
                        </div>

                        {/* Descrição */}
                        <div>
                            <label className="form-label small fw-bold">Descrição</label>
                            <input type="text" className="form-control" name="descricao" value={filtrosForm.descricao} onChange={handleFiltroChange} placeholder="Nome do produto..." />
                        </div>

                        {/* Marca */}
                        <div>
                            <label className="form-label small fw-bold">Marca</label>
                            <input type="text" className="form-control" name="marca" value={filtrosForm.marca} onChange={handleFiltroChange} placeholder="Ex: Nike" />
                        </div>

                        {/* Fornecedor */}
                        <div>
                            <label className="form-label small fw-bold">Fornecedor</label>
                            <input type="text" className="form-control" name="fornecedor" value={filtrosForm.fornecedor} onChange={handleFiltroChange} placeholder="Nome do fornecedor..." />
                        </div>

                        {/* Valores Venda */}
                        <div className="row g-2">
                            <div className="col-6">
                                <label className="form-label small fw-bold">Preço Venda Min</label>
                                <input type="number" className="form-control" name="valor_venda_min" value={filtrosForm.valor_venda_min} onChange={handleFiltroChange} placeholder="0.00" />
                            </div>
                            <div className="col-6">
                                <label className="form-label small fw-bold">Preço Venda Max</label>
                                <input type="number" className="form-control" name="valor_venda_max" value={filtrosForm.valor_venda_max} onChange={handleFiltroChange} placeholder="0.00" />
                            </div>
                        </div>

                        {/* Valores Compra */}
                        <div className="row g-2">
                            <div className="col-6">
                                <label className="form-label small fw-bold">Preço Compra Min</label>
                                <input type="number" className="form-control" name="valor_compra_min" value={filtrosForm.valor_compra_min} onChange={handleFiltroChange} placeholder="0.00" />
                            </div>
                            <div className="col-6">
                                <label className="form-label small fw-bold">Preço Compra Max</label>
                                <input type="number" className="form-control" name="valor_compra_max" value={filtrosForm.valor_compra_max} onChange={handleFiltroChange} placeholder="0.00" />
                            </div>
                        </div>

                        {/* Cores */}
                        <div>
                            <label className="form-label small fw-bold">Cores</label>
                            <input type="text" className="form-control" name="cor" value={filtrosForm.cor} onChange={handleFiltroChange} placeholder="Ex: Azul" />
                        </div>

                        {/* Grades (Select) */}
                        <div>
                            <label className="form-label small fw-bold">Grades</label>
                            <select className="form-select" name="grade_id" value={filtrosForm.grade_id} onChange={handleFiltroChange}>
                                <option value="">Todas</option>
                                {listaGrades.map(g => (
                                    <option key={g.id} value={g.id}>{g.descricao}</option>
                                ))}
                            </select>
                        </div>

                        {/* Observações (Último) */}
                        <div>
                            <label className="form-label small fw-bold">Observações</label>
                            <input type="text" className="form-control" name="observacoes" value={filtrosForm.observacoes} onChange={handleFiltroChange} placeholder="Termo nas observações..." />
                        </div>



                    </div>
                </Offcanvas.Body>
            </Offcanvas>

        </div>
    );
}

export default Produtos;